import { useMemo } from 'react';
import { format, eachDayOfInterval } from 'date-fns';
import type { DayTheme } from '@/types';
import { DayThemeSelector } from './DayThemeSelector';
import styles from '@/pages/WeeklyPlanningPage.module.css';

export interface DayThemesGridProps {
  weekStart: Date;
  weekEnd: Date;
  dayThemes: Record<string, DayTheme>;
  onThemeChange: (dateKey: string, theme: DayTheme) => void;
}

export function DayThemesGrid({
  weekStart,
  weekEnd,
  dayThemes,
  onThemeChange,
}: DayThemesGridProps) {
  const days = useMemo(() => {
    return eachDayOfInterval({ start: weekStart, end: weekEnd });
  }, [weekStart, weekEnd]);

  return (
    <section className={styles.themesSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Day Themes</h2>
        <span className={styles.themesHint}>Click to set each day&apos;s focus</span>
      </div>

      <div className={styles.themesGrid}>
        {days.map((day) => {
          const dateKey = format(day, 'yyyy-MM-dd');
          return (
            <DayThemeSelector
              key={dateKey}
              date={day}
              theme={dayThemes[dateKey] || null}
              onChange={onThemeChange}
            />
          );
        })}
      </div>
    </section>
  );
}
